import { render, staticRenderFns } from "./Roster.vue?vue&type=template&id=6517f68e&scoped=true&"
import script from "@/views/Users/Student/Roster.ts?vue&type=script&lang=ts&"
export * from "@/views/Users/Student/Roster.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Users/Student/roster.scss?vue&type=style&index=0&id=6517f68e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6517f68e",
  null
  
)

export default component.exports